import FindScholarships from "./FindScholarships";
import React, { useContext }  from "react";
import { useTranslation } from 'react-i18next';
import { LoginContext } from "./LoginContext";
/**
 *
 */
export default function MainContainer() {
    const { t, i18n } = useTranslation();
    const user = useContext(LoginContext);
    const isLoggedIn = user && user.authenticated

    return (
        <div className="layout-main">
            <main id="MainContent">
                <div className="container-fluid">
                    <div className="container">
                        <div className="row">
                            <div className="col">
                                <nav aria-label="Du är här" className="breadcrumbs">
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item"><a href="https://www.uu.se/">{t('head.university_name')}</a></li>
                                        <li className="breadcrumb-item">{ i18n.resolvedLanguage === 'en' ? <a href="https://www.uu.se/en/students/student-life/student-finance/scholarships">{t('head.link_scholarship_page')}</a> : <a href="https://www.uu.se/student/studentliv/studentekonomi/stipendier">{t('head.link_scholarship_page')}</a>}</li>
                                        <li className="breadcrumb-item active" aria-current="page">{t('head.title')}</li>
                                    </ol>
                                </nav>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div className="row">
                        <div className={ isLoggedIn ? "col-lg-3" : "" }>
                            { isLoggedIn &&
                                <nav className="navbar-expand-lg mainMenu is-no-print" aria-label="Huvudmeny">
                                    <div className="collapse navbar-collapse" id="navigation">
                                        <ul className="nav flex-column">
                                            <li><a href="/stipendium/stipac/sok" aria-current="page" className="nav-link current">{t('menu.available_scholarships')}</a></li>
                                            <li><a href={'/stipendium/stipac/ansokan/ansokning?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.start')}</a></li>
                                            <li><a href={'/stipendium/stipac/ansokan/ansokningar?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.applications')}</a></li>
                                            <li><a href={'/stipendium/stipac/ansokan/innehav?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.holding_of_scholarships')}</a></li>
                                            <li><a href={'/stipendium/stipac/ansokan/bevakning?lang=' + i18n.resolvedLanguage} className="nav-link noncurrent">{t('menu.monitoring_of_scholarships')}</a></li>
                                        </ul>
                                    </div>
                                </nav>
                            }
                        </div>
                        <div className="col">
                            <FindScholarships />
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );

}